import { useDispatch } from 'react-redux';

import { AsyncReducerStatus } from 'store/common/AsyncReducerStatus';
import { useTypedSelector } from 'store/common/TypedSelector';

import { DeviceViewModel } from 'services/device/domain/model/DeviceModel';
import { DeviceDeleteForm } from 'services/device/presentation/ui/device-action/device-delete-form/DeviceDeleteForm';
import { DeviceDeleteFailedNotification } from 'services/device/presentation/ui/device-action/device-delete-modal/DeviceDeleteFailedNotification';
import { deleteDevice } from 'services/device/store/devicesSlice';

import { ModalDialogue } from 'presentation/ui/compositions/modal-dialogue/ModalDialogue';
import { ModalDialogueHeight } from 'presentation/ui/compositions/modal-dialogue/ModalDialogueHeight';

export interface DeviceDeleteModalProps {
	device: DeviceViewModel
	onDismiss?: () => void;
}

export const DeviceDeleteModal = (props: DeviceDeleteModalProps): JSX.Element => {
	const { device, onDismiss } = props;

	const deviceActionStatus = useTypedSelector(state => state.devices.actionStatus);

	const dispatch = useDispatch();

	const handleDelete = (): void => {
		dispatch(deleteDevice(device));
	};

	const renderModalContent = () => {
		let modalContent: JSX.Element = null;

		switch (deviceActionStatus) {
			case AsyncReducerStatus.IDLE:
				modalContent =
					<DeviceDeleteForm
						device={device}
						onDelete={handleDelete}
						onDismiss={onDismiss}
					/>;
				break;

			case AsyncReducerStatus.FAILED:
				modalContent = <DeviceDeleteFailedNotification
					onDismiss={onDismiss}
				/>;
				break;
		}

		return modalContent;
	};

	return (
		<ModalDialogue height={ModalDialogueHeight.HEIGHT_FLEX}>
			{renderModalContent()}
		</ModalDialogue>
	);
};
